import httpManager from "@/app/shared/utils/httpManager";

import { Node } from "@/@types/chatbots";

export async function validateChannelCustomerSchedule(params: any): Promise<Node[]> {
  const response = await httpManager.post(`/chatbots/validate-channel-customer-schedule/`, params);

  console.log("validateChannelCustomerSchedule response", response);
  return response?.data;
}
